import { useEffect, useState } from "react";
import { api, apiError, tl } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Rocket, Loader2, Check, Lock, TrendingUp, Clock } from "lucide-react";
import { toast } from "sonner";

export function BoostModal({ open, onOpenChange, type = "usta", jobId, onDone }) {
  const [pkgs, setPkgs] = useState([]);
  const [status, setStatus] = useState(null);
  const [buying, setBuying] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/boost-packages");
      setPkgs(data);
    } catch { /* ignore */ }
    if (type === "usta") {
      try { const { data } = await api.get("/boost/status"); setStatus(data); } catch { /* ignore */ }
    }
  };
  useEffect(() => { if (open) load(); }, [open, type]);

  const locked = type === "usta" && status?.slots_full;

  const buy = async (pkg) => {
    setBuying(pkg.id);
    try {
      if (type === "job") await api.post(`/jobs/${jobId}/boost`, { package_id: pkg.id });
      else await api.post("/boost/purchase", { package_id: pkg.id });
      toast.success("Öne çıkarma başarılı! 🚀");
      onDone && onDone();
      onOpenChange(false);
    } catch (e) { toast.error(apiError(e)); }
    finally { setBuying(null); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="boost-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Rocket className="h-5 w-5 text-emerald-500" /> {type === "job" ? "İlanı Öne Çıkar" : "Vitrinde Öne Çık"}</DialogTitle>
        </DialogHeader>

        {type === "usta" && status && (
          <div className="text-sm rounded-xl bg-slate-50 border border-slate-100 p-3 text-slate-600">
            Vitrin doluluğu: <span className="font-bold text-emerald-600">{status.slots_used}/5</span>
            {status.active_boost && <span className="ml-2 text-emerald-600 font-semibold">• Şu an öne çıkıyorsunuz</span>}
          </div>
        )}

        {locked ? (
          <div className="flex flex-col items-center text-center py-6 text-slate-500" data-testid="boost-locked">
            <Lock className="h-10 w-10 text-slate-300" />
            <p className="mt-3 font-semibold text-slate-700">Vitrin şu an dolu (5/5)</p>
            <p className="text-sm mt-1">Bir kontenjan boşaldığında tekrar deneyebilirsiniz.</p>
          </div>
        ) : (
          <div className="space-y-3 mt-1">
            {pkgs.map((p) => (
              <button key={p.id} onClick={() => buy(p)} disabled={buying} data-testid={`boost-pkg-${p.duration_hours}`}
                className="w-full text-left rounded-2xl border-2 border-slate-200 hover:border-emerald-400 p-4 transition-colors flex items-center justify-between gap-3">
                <div>
                  <div className="flex items-center gap-1.5 font-extrabold text-slate-900"><Clock className="h-4 w-4 text-emerald-500" /> {p.duration_hours} Saat</div>
                  <div className="mt-1 flex items-center gap-2">
                    {p.savings > 0 && <span className="text-sm text-slate-400 line-through">{tl(p.normal_price)}</span>}
                    <span className="text-lg font-extrabold text-emerald-600">{tl(p.sale_price)}</span>
                  </div>
                  {p.savings > 0 && (
                    <div className="mt-1 inline-flex items-center gap-1 text-[11px] font-bold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full">
                      <TrendingUp className="h-3 w-3" /> %{p.discount_percent} indirim — {tl(p.savings)} kazançtasın!
                    </div>
                  )}
                </div>
                {buying === p.id ? <Loader2 className="h-5 w-5 animate-spin text-emerald-500" /> : <span className="h-8 w-8 rounded-full brand-gradient text-white flex items-center justify-center"><Check className="h-4 w-4" /></span>}
              </button>
            ))}
            {pkgs.length === 0 && <p className="text-sm text-slate-400 text-center py-4">Henüz paket yok.</p>}
          </div>
        )}
        <p className="text-[11px] text-slate-400 mt-1">Tutar cüzdan bakiyenizden düşer. Süre bitince otomatik olarak vitrinden çıkarsınız.</p>
      </DialogContent>
    </Dialog>
  );
}
